<template>
  <v-toolbar flat dense>

    <v-spacer></v-spacer>

    <v-btn
      title="Acesso"
      :to="'/persons/'+personId+'/grant'"
      text
      icon
      color="warning"
    >
      <v-icon>mdi-door-open</v-icon>
    </v-btn>
    <v-btn
      title="Digitais"
      :to="'/persons/'+personId+'/fingerprints'"
      text
      icon
      color="blue"
    >
      <v-icon>mdi-fingerprint</v-icon>
    </v-btn>

    <v-btn
      title="Histórico de Acesso"
      :to="'/persons/'+personId+'/accesslog'"
      text
      icon
      color="gray"
    >
      <v-icon>mdi-clock</v-icon>
    </v-btn>
    <v-btn
      :to="'/persons/'+personId+'/edit'"
      text
      icon
      color="blue"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>

    export default {
        name: 'PersonToolbar',
        props: {
            personId: {
                type: String,
            }
        }
    }

</script>
